import React from 'react'

export function EidField(props) {
  const onChange = (e) => {
    const value = e.target.value
    if (!value) {
      return props.onChange(value)
    }

    let eid
    //Replace non-numeric charaters
    let input = value.replace(/[^\d]/g, '')
    if (input.length > 32) {
      input = input.substring(0, 32)
    }

    if (input.length < 6) {
      eid = input
    } else if (input.length < 11) {
      eid = input.substring(0, 5) + ' ' + input.substring(5)
    } else if (input.length < 16) {
      eid = input.substring(0, 5) + ' ' + input.substring(5, 10) + ' ' + input.substring(10)
    } else if (input.length < 21) {
      eid =
        input.substring(0, 5) +
        ' ' +
        input.substring(5, 10) +
        ' ' +
        input.substring(10, 15) +
        ' ' +
        input.substring(15)
    } else if (input.length < 26) {
      eid =
        input.substring(0, 5) +
        ' ' +
        input.substring(5, 10) +
        ' ' +
        input.substring(10, 15) +
        ' ' +
        input.substring(15, 20) +
        ' ' +
        input.substring(20)
    } else if (input.length < 31) {
      eid =
        input.substring(0, 5) +
        ' ' +
        input.substring(5, 10) +
        ' ' +
        input.substring(10, 15) +
        ' ' +
        input.substring(15, 20) +
        ' ' +
        input.substring(20, 25) +
        ' ' +
        input.substring(25)
    } else {
      eid =
        input.substring(0, 5) +
        ' ' +
        input.substring(5, 10) +
        ' ' +
        input.substring(10, 15) +
        ' ' +
        input.substring(15, 20) +
        ' ' +
        input.substring(20, 25) +
        ' ' +
        input.substring(25, 30) +
        ' ' +
        input.substring(30)
    }

    props.onChange(eid)
  }

  return (
    <input
      className={props.className}
      type="text"
      name={props.name}
      value={props.value}
      onChange={onChange}
    />
  )
}
